export const formatMoney = (money) => {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'GBP',
  }).format(money);
};
